// Home's Moment Card: offer strip, the ordered action list (first visible = primary) and per-action label + icon.
import { Component, Input } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { OmpMoment, OmpMomentAction, OmpMomentActionDef } from '../../../_models';
import {
  OmpMomentActionDefs,
  OmpMomentActionsField,
  OmpMomentDiscountMoments,
} from '../../order-management-portal.sections';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-moment-card-settings',
  templateUrl: './moment-card-settings.component.html',
  styleUrls: ['./moment-card-settings.component.scss'],
})
export class OmpMomentCardSettingsComponent extends OmpSectionSettings {
  @Input() moment: OmpMoment;

  get actions(): OmpMomentAction[] {
    const list = this.data ? this.data[OmpMomentActionsField] : null;
    return Array.isArray(list) ? list : [];
  }

  get hasDiscount(): boolean {
    return OmpMomentDiscountMoments.indexOf(this.moment) >= 0;
  }

  get primaryKey(): string {
    let key = null;
    this.actions.forEach((action) => {
      if (!key && action.is_visible) {
        key = action.key;
      }
    });
    return key;
  }

  def(action: OmpMomentAction): OmpMomentActionDef {
    return OmpMomentActionDefs[action.key];
  }

  onActionDrop(event: CdkDragDrop<OmpMomentAction[]>) {
    if (event.previousIndex !== event.currentIndex) {
      const list = this.actions.slice();
      moveItemInArray(list, event.previousIndex, event.currentIndex);
      this.set(OmpMomentActionsField, list);
    }
  }

  setAction(action: OmpMomentAction, field: string, value: any) {
    action[field] = value;
    this.change.emit();
  }
}
